import { Theme } from '@mui/material/styles';

export const filtersStyles = ({ spacing }: Theme) => ({ width: 400, padding: spacing(2) });

export const tooltipStyles = { zIndex: 100 };

export const filterBtnStyles = ({ palette, spacing }: Theme) => ({
    borderWidth: 1,
    borderColor: palette.grey[400],
    color: palette.grey[700],
    fontWeight: 400,
    padding: '7px 15px',
    '&:hover, &:focus': {
        borderColor: palette.common.black,
        backgroundColor: palette.common.white,
    },

    '& .MuiButton-endIcon': {
        color: palette.grey[400],
    },
    '&.isOpened': {
        borderColor: palette.primary.main,
    },
});
